import { CONTEXT_LOG_COMPLETION_STATUS, CONTEXT_LOG_STATUS, CONTEXT_LOG_SUBJECT_TYPES, ContextLogParams } from "@/types/contextLogTypes";

export class ContextLog {
  id: string;
  subjectId: string;
  subjectType: CONTEXT_LOG_SUBJECT_TYPES;
  note: string;
  userEmail: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  status: CONTEXT_LOG_STATUS;
  completionStatus: CONTEXT_LOG_COMPLETION_STATUS;
  procedureContextBreadcrumb: string;
  propelOrgId: string;

  constructor(params: ContextLogParams) {
    this.id = params.id;
    this.subjectId = params.subjectId;
    this.subjectType = params.subjectType;
    this.note = params.note;
    this.userEmail = params.userEmail;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.status = params.status;
    this.completionStatus = params.completionStatus || CONTEXT_LOG_COMPLETION_STATUS.NOT_APPLICABLE;
    this.procedureContextBreadcrumb = params.procedureContextBreadcrumb || '';
    this.propelOrgId = params.propelOrgId || '';
  }
}
